import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ff1d09c8"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "filter row m-3" };
const _hoisted_2 = { class: "col-1" };
const _hoisted_3 = { class: "col" };
const _hoisted_4 = { class: "table table-hover table-striped" };
const _hoisted_5 = { class: "col-2" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", { class: "col-2" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Groep")
], -1));
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", { class: "col-2" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Teamnaam")
], -1));
const _hoisted_8 = { class: "col-1" };
const _hoisted_9 = { class: "col-1" };
const _hoisted_10 = { class: "col-1" };
const _hoisted_11 = { class: "col-2" };
const _hoisted_12 = { class: "col-2" };
const _hoisted_13 = { class: "col-2" };
const _hoisted_14 = { class: "col-2" };
const _hoisted_15 = { class: "col-1" };
const _hoisted_16 = { class: "col-1" };
const _hoisted_17 = { class: "col-2" };
const _hoisted_18 = {
    key: 0,
    class: "d-flex flex-wrap gap-2"
};
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-info-circle" }, null, -1));
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-edit" }, null, -1));
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-trash" }, null, -1));
import { ref, computed, onMounted, onUnmounted, watchEffect } from 'vue';
import TeamView from '../TeamView';
import TeamEdit from '../TeamEdit';
import { getScoresForTeam } from '@/types/teams';
import { useToast } from 'vue-toastification';
import { ModalBox, Button } from '@/components/UI';
import { getCurrentInstance } from 'vue';
import Icon from '@/components/UI/Icon/Icon.vue';
import TextInput from '@/components/UI/TextInput/TextInput.vue';
import { useArchivedGroups } from '@/compositions/useGroups';
export default /*#__PURE__*/ _defineComponent({
    props: {
        teamtype: null,
        actions: null
    },
    setup(__props) {
        const props = __props;
        const { proxy } = getCurrentInstance();
        const store = proxy === null || proxy === void 0 ? void 0 : proxy.$store;
        const actions = computed(() => { var _a; return (_a = props.actions) !== null && _a !== void 0 ? _a : []; });
        const toast = useToast();
        const { archivedGroups } = useArchivedGroups();
        const editTeam = ref(null);
        const infoTeam = ref(null);
        const editVisible = ref(false);
        const filterText = ref('');
        const groupNames = ref({});
        async function loadGroupName(id) {
            var _a;
            if (groupNames.value[id])
                return groupNames.value[id];
            groupNames.value[id] = ((_a = archivedGroups.value[id]) === null || _a === void 0 ? void 0 : _a.name) || '';
            return groupNames.value[id];
        }
        const teams = computed(() => {
            const allTeams = store.direct.state.teams[props.teamtype];
            const allTeamsArray = Object.values(allTeams)
                .filter(team => {
                var _a;
                return team.name.toLowerCase().includes(filterText.value.toLowerCase()) ||
                    (team.group && ((_a = groupNames.value[team.group]) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(filterText.value.toLowerCase())));
            }).sort((a, b) => {
                var _a, _b;
                return (a.group && b.group ?
                    (((_a = archivedGroups.value[b.group]) === null || _a === void 0 ? void 0 : _a.start_time) || 0) - (((_b = archivedGroups.value[a.group]) === null || _b === void 0 ? void 0 : _b.start_time) || 0) : 0);
            });
            return allTeamsArray.slice(0, 50);
        });
        onMounted(() => {
            store.direct.dispatch.teams.subscribe(props.teamtype);
            store.direct.dispatch.rfid.subscribe();
        });
        onUnmounted(() => {
            store.direct.dispatch.teams.unsubscribe(props.teamtype);
            store.direct.dispatch.rfid.unsubscribe();
        });
        watchEffect(() => {
            Object.values(teams.value).forEach(async (team) => {
                if (team.group)
                    await loadGroupName(team.group);
            });
        });
        async function updateTeam(team) {
            const successmessage = `Team ${team.name} has been saved`;
            const failmessage = 'Could not update team, ';
            try {
                await store.direct.dispatch.teams.update(team);
                toast.success(successmessage);
            }
            catch (error) {
                toast.error(failmessage + error);
            }
            editVisible.value = false;
        }
        async function deleteTeam(teamid) {
            console.log('Deleting team', teamid);
            try {
                await store.direct.dispatch.teams.delete(teamid);
                toast.success(`Team has been deleted`);
            }
            catch (error) {
                if (error instanceof Error) {
                    toast.error(error.message);
                }
            }
        }
        function getPrintedStartTime(team) {
            var _a, _b;
            const starttime = (_b = (_a = archivedGroups.value) === null || _a === void 0 ? void 0 : _a[team.group + '']) === null || _b === void 0 ? void 0 : _b.start_time;
            if (!starttime)
                return 'N/A';
            const date = new Date(starttime * 1000);
            return date.toLocaleString();
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("span", _hoisted_2, [
                        _createVNode(Icon, { name: "search" })
                    ]),
                    _createElementVNode("span", _hoisted_3, [
                        _createVNode(TextInput, {
                            modelValue: filterText.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((filterText).value = $event))
                        }, null, 8, ["modelValue"])
                    ])
                ]),
                _createElementVNode("table", _hoisted_4, [
                    _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_5, [
                                _createVNode(Icon, { name: 'clock' })
                            ]),
                            _hoisted_6,
                            _hoisted_7,
                            _createElementVNode("td", _hoisted_8, [
                                _createVNode(Icon, { name: 'trophy' })
                            ]),
                            _createElementVNode("td", _hoisted_9, [
                                _createVNode(Icon, { name: 'users' })
                            ]),
                            _createElementVNode("td", _hoisted_10, [
                                _createVNode(Icon, { name: 'gamepad' })
                            ]),
                            _createElementVNode("td", _hoisted_11, [
                                _createVNode(Icon, { name: 'actions' })
                            ])
                        ])
                    ]),
                    _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(teams), (team) => {
                            var _a;
                            return (_openBlock(), _createElementBlock("tr", {
                                key: team.id
                            }, [
                                _createElementVNode("td", _hoisted_12, _toDisplayString(getPrintedStartTime(team)), 1),
                                _createElementVNode("td", _hoisted_13, _toDisplayString(groupNames.value[(_a = team.group) !== null && _a !== void 0 ? _a : ''] || 'N/A'), 1),
                                _createElementVNode("td", _hoisted_14, _toDisplayString(team.name), 1),
                                _createElementVNode("td", _hoisted_15, _toDisplayString(Object.values(_unref(getScoresForTeam)(team)).reduce((sum, current) => sum + current, 0)), 1),
                                _createElementVNode("td", _hoisted_16, _toDisplayString(team.members.length), 1),
                                _createElementVNode("td", _hoisted_17, [
                                    (_unref(actions).length > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                            (_unref(actions).includes('info'))
                                                ? (_openBlock(), _createBlock(_unref(Button), {
                                                    key: 0,
                                                    variant: "info",
                                                    onClick: ($event) => (infoTeam.value = team)
                                                }, {
                                                    default: _withCtx(() => [
                                                        _hoisted_19
                                                    ]),
                                                    _: 2
                                                }, 1032, ["onClick"]))
                                                : _createCommentVNode("", true),
                                            (_unref(actions).includes('edit'))
                                                ? (_openBlock(), _createBlock(_unref(Button), {
                                                    key: 1,
                                                    variant: "success",
                                                    onClick: ($event) => { editTeam.value = team; editVisible.value = true; }
                                                }, {
                                                    default: _withCtx(() => [
                                                        _hoisted_20
                                                    ]),
                                                    _: 2
                                                }, 1032, ["onClick"]))
                                                : _createCommentVNode("", true),
                                            (_unref(actions).includes('delete'))
                                                ? (_openBlock(), _createBlock(_unref(Button), {
                                                    key: 2,
                                                    variant: "danger",
                                                    onClick: ($event) => (deleteTeam(team.id))
                                                }, {
                                                    default: _withCtx(() => [
                                                        _hoisted_21
                                                    ]),
                                                    _: 2
                                                }, 1032, ["onClick"]))
                                                : _createCommentVNode("", true)
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ]));
                        }), 128))
                    ])
                ]),
                (infoTeam.value !== null)
                    ? (_openBlock(), _createBlock(_unref(ModalBox), {
                        key: 0,
                        title: "Team Overview",
                        size: "lg",
                        onSubmit: _cache[1] || (_cache[1] = ($event) => (infoTeam.value !== null && updateTeam({ ...infoTeam.value, id: infoTeam.value.id }))),
                        onClose: _cache[2] || (_cache[2] = ($event) => (infoTeam.value = null))
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(TeamView), { team: infoTeam.value }, null, 8, ["team"])
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                (editVisible.value && editTeam.value !== null)
                    ? (_openBlock(), _createBlock(_unref(ModalBox), {
                        key: 1,
                        title: "Edit team",
                        size: "lg",
                        submitButtonTitle: "Save",
                        onSubmit: _cache[3] || (_cache[3] = ($event) => (editTeam.value !== null && updateTeam({ ...editTeam.value, id: editTeam.value.id }))),
                        onClose: _cache[4] || (_cache[4] = ($event) => (editVisible.value = false))
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(TeamEdit), { team: editTeam.value }, null, 8, ["team"])
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
